document.addEventListener("DOMContentLoaded", function () {
  /* ===============================
     ハンバーガーメニュー
  =============================== */
  const btn = document.querySelector(".or__header__btn");
  const menu = document.querySelector(".hamburger__menu");
  const header = document.querySelector(".or__header");
  const closeBtn = document.querySelector(".hamburger__menu--close");

  if (btn && menu && header) {
    // 開閉ボタン
    btn.addEventListener("click", () => {
      menu.classList.toggle("active");
      header.classList.toggle("active");
      btn.classList.toggle("open");
    });

    // 閉じるボタン
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        menu.classList.remove("active");
        header.classList.remove("active");
        btn.classList.remove("open");
      });
    }
  }

  /* ===============================
     フローティングバナー
  =============================== */
  const floatingClose = document.querySelector(".floatingBnr__close");
  const floatingBanner = document.querySelector(".floatingBnr");

  if (floatingClose && floatingBanner) {
    floatingClose.addEventListener("click", () => {
      floatingBanner.style.display = "none";
    });
  }

  /* ===============================
     FAQアコーディオン
  =============================== */
  const accTitles = document.querySelectorAll(".faq__item--title");

  if (accTitles.length > 0) {
    accTitles.forEach((ttl) => {
      const content = ttl.nextElementSibling;
      if (!content) return; // 安全チェック
      ttl.addEventListener("click", () => {
        ttl.classList.toggle("is_active");
        if (content.style.height) {
          content.style.height = null;
        } else {
          content.style.height = content.scrollHeight + "px";
        }
      });
    });
  }

  /* ===============================
     関連スライダー（SP時のみ）
  =============================== */
  let relatedSlider = null;
  const breakpoint = 768;
  const container = document.querySelector(".related__slider");

  function initRelatedSlider() {
    if (!container || typeof Swiper === "undefined") return;

    if (window.innerWidth <= breakpoint && !relatedSlider) {
      relatedSlider = new Swiper(".related__slider", {
        slidesPerView: 2.2,
        spaceBetween: 15,
        freeMode: false,
        grabCursor: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    } else if (window.innerWidth > breakpoint && relatedSlider) {
      relatedSlider.destroy(true, true);
      relatedSlider = null;
    }
  }

  // 初期化
  window.addEventListener("load", initRelatedSlider);
  window.addEventListener("resize", initRelatedSlider);

    /* ===============================
     関連スライダー（SP時のみ）
  =============================== */
  let InstagramSlider = null;
  const container2 = document.querySelector(".instagram__slider");

function initInstagramSlider() {
  if (!container2 || typeof Swiper === "undefined") return;

  if (!InstagramSlider) {
    InstagramSlider = new Swiper(".instagram__slider", {
      spaceBetween: 15,
      freeMode: false,
      grabCursor: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      slidesPerView: 2.2,  // デフォルト（SP）

      breakpoints: {
        768: {
          loop:true,
          slidesPerView: 3, // PC
        }
      }
    });
  }
}

  // 初期化
  window.addEventListener("load", initInstagramSlider);
  window.addEventListener("resize", initInstagramSlider);
});
